import { Directive, ElementRef, EventEmitter, Input, Output } from "@angular/core";

@Directive({
	selector: "[elementIsIntoView]",
	standalone: false
})
export class ElementIsIntoViewDirective {
	@Output() public scrolledIntoView: EventEmitter<void> = new EventEmitter<void>();
	private _observer: IntersectionObserver | undefined;

	constructor(private el: ElementRef) {}

	private createAndObserve(): void {
		/**
		 * @property {HTMLElement} root - ancestor element which contains the observable elements
		 * @property {number|number[]} treshhold - percentage/s of the target visibility. 1 meaning 100% of visibility is needed for the observer to be triggered
		 */
		const options = {
			root: null,
			threshold: 0.1
		};

		this._observer = new IntersectionObserver((entries, observer) => {
			entries.forEach((entry: IntersectionObserverEntry) => {
				if (entry.isIntersecting) {
					this.scrolledIntoView.emit();
					observer.unobserve(entry.target);
				}
			});
		}, options);
		this._observer.observe(this.el.nativeElement);
	}
	/**
	 * Setup an IntersectionObserver only when element should be observable
	 */
	@Input("elementIsIntoView") set makeItObservable(isObservable: boolean) {
		if (isObservable) {
			this.createAndObserve();
		}
	}
}
